import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import writtenNumber from "written-number";
import { openModal } from "../../../actions/modalAction";
import {
  fetchPropCom,
  resetPropCom,
} from "../../../actions/propertyComAction_Ggn";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import { Form, Button } from "semantic-ui-react";
import TextInput from "../../form/TextInput";
import TextArea from "../../form/TextArea";
import SelectInput from "../../form/SelectInput";
import DateInput from "../../form/DateInput";
import NumberInput from "../../form/NumberInput";

import {
  propertyForOption,
  propertyType,
  // category,
  bedroom,
  bathroom,
  furnishedStatus,
  interior,
  // ac,
  // fan,
  status,
  transactionType,
  loanOfferedBy,
  typeOfOwnership,
  facing,
  entry,
  Overlooking,
  // carParkingCovered,
  // carParkingOpen,
  floorNo,
  totalFloors,
  // locality,
  //************
  numberOption,
  booleanOption,
  frequency,
  companyLease,
  agreement,
  //******
  propcomStatus,
  projectType,
  amenitiesDwarka,
  conversionFactors,
} from "./Data";
import { projectNameCom, locality } from "../../functions/DataFunctions";

import { combineValidators, isRequired } from "revalidate";

const validate = combineValidators({
  areaPlotUnit: isRequired("Plot Area Unit"),
  areaCarpetUnit: isRequired("Carpet Area Unit"),
  areaSuperUnit: isRequired("Super Area Unit"),
  areaBuiltUpUnit: isRequired("BuiltUp Area Unit"),

  propertyFor: isRequired("Property For"),
  category: isRequired("Category"),
  propertyType: isRequired("Property Type"),
  // bathroom : isRequired('Bathroom'),
  furnishedStatus: isRequired("Furnished Status"),
  status: isRequired("Status"),
  expectedPrice: isRequired("Demand"),
  expectedRent: isRequired("Rent Demand"),
  //projectName: isRequired("Project Name"),
  projectType: isRequired("Project Type"),
  locality: isRequired("Locality"),

  propcomStatus: isRequired("propcom Status"),
});

class PropComEdit extends Component {
  componentDidMount() {
    const { id } = this.props;
    this.props.fetchPropCom(id);
  }
  componentWillUnmount() {
    this.props.resetPropCom();
  }
  //**** */

  backButtonHandler = () => {
    this.props.history.goBack();
  };

  //** */

  onSubmit = async (values) => {
    //************
    try {
      const { id } = this.props;
      const res = await axios.put(`/api/ggn/PropComEdit/${id}`, values);

      if (res.data.msg === "success") {
        toastr.success("Updated Successfully");
        this.props.handleEditModalCloseSubmit();
      }
    } catch (error) {
      console.log("error_updatePropCom", error);
      if (error && error.response && error.response.status == 401) {
        this.props.openModal("LoginModal");
        toastr.error(`${JSON.stringify(error.response.data)}`);
      } else if (error) {
        toastr.error(
          "Oops",
          "Something went wrong.Please Try Again_editPropCom"
        );
      }
    }
    //**********
  };

  render() {
    const {
      // aproxValueOfWork,
      expectedPrice,
      expectedRent,
      securityDeposit,
      otherCharges,
      maintenanceCharges,
      propertyFor,
      areaPlot,
      areaCarpet,
      areaSuper,
      areaBuiltUp,
    } =
      this.props.state.form &&
      this.props.state.form.PropComEdit !== undefined &&
      this.props.state.form.PropComEdit.values !== undefined &&
      this.props.state.form.PropComEdit.values;
    const { handleSubmit, pristine, reset, submitting } = this.props;

    const renderSaleOrRentField = () => {
      if (propertyFor === "SALE") {
        return (
          <React.Fragment>
            <label>
              Demand{" "}
              <span>
                <b>
                  (
                  {writtenNumber(expectedPrice, {
                    lang: "enIndian",
                  }).toUpperCase()}
                  ){" "}
                </b>
              </span>
            </label>
            <span className="color-mandatory"> * </span>
            <Field
              name="expectedPrice"
              placeholder="Demand"
              type="number"
              component={NumberInput}
            />
          </React.Fragment>
        );
      } else {
        if (propertyFor === "RENT") {
          return (
            <React.Fragment>
              <label>
                Rent Demand{" "}
                <span>
                  <b>
                    (
                    {writtenNumber(expectedRent, {
                      lang: "enIndian",
                    }).toUpperCase()}
                    ){" "}
                  </b>
                </span>
              </label>
              <span className="color-mandatory"> * </span>
              <Field
                name="expectedRent"
                placeholder="Rent Demand"
                type="number"
                component={NumberInput}
              />
              <label>
                SecurityDeposit{" "}
                <span>
                  <b>
                    (
                    {writtenNumber(securityDeposit, {
                      lang: "enIndian",
                    }).toUpperCase()}
                    ){" "}
                  </b>
                </span>
              </label>
              <Field
                name="securityDeposit"
                placeholder="SecurityDeposit"
                type="number"
                component={NumberInput}
              />
              <label>
                Maintenance Charges{" "}
                <span>
                  <b>
                    (
                    {writtenNumber(maintenanceCharges, {
                      lang: "enIndian",
                    }).toUpperCase()}
                    ){" "}
                  </b>
                </span>
              </label>
              <Field
                name="maintenanceCharges"
                placeholder="Maintenance Charges"
                type="number"
                component={NumberInput}
              />
              <label>Frequency Of Maintenance Charges</label>
              <Field
                name="unitMaintenanceCharges"
                placeholder="Monthly,Quarterly,Yearly,One-Time"
                type="text"
                options={frequency()}
                search={true}
                component={SelectInput}
              />
              <label>
                Other Charges{" "}
                <span>
                  <b>
                    (
                    {writtenNumber(otherCharges, {
                      lang: "enIndian",
                    }).toUpperCase()}
                    ){" "}
                  </b>
                </span>
              </label>
              <Field
                name="otherCharges"
                placeholder="Other Charges"
                type="number"
                component={NumberInput}
              />
              <label>Frequency Of Other Charges</label>
              <Field
                name="unitOtherCharges"
                placeholder="Monthly,Quarterly,Yearly,One-Time"
                type="text"
                options={frequency()}
                search={true}
                component={SelectInput}
              />

              <label>Company Lease</label>
              <Field
                name="companyLease"
                placeholder="Company Lease"
                type="text"
                options={companyLease()}
                //search={true}
                component={SelectInput}
              />
              <label>Agreement Type</label>
              <Field
                name="agreement"
                placeholder="Agreement Type"
                type="text"
                options={agreement()}
                //search={true}
                component={SelectInput}
              />
            </React.Fragment>
          );
        }
      }
    };

    //*************** */

    return (
      <div
        className="font-family-Roboto"
        style={{ maxWidth: "700px", margin: "auto" }}
      >
        {/**/}
        <div
          className="card-attached border-radius-top "
          style={{ textAlign: "center", backgroundColor: "skyblue" }}
        >
          <div
            style={{
              fontSize: "1.3rem",
              fontWeight: "bold",
              padding: "10px",
            }}
          >
            {/*  */}
            Edit Commercial Property {propertyFor}
            {/*  */}
          </div>
        </div>
        {/**/}

        <div className="card-attached border-radius-bottom pxy-20">
          <div className=" label">
            <Form onSubmit={handleSubmit(this.onSubmit)}>
              <Button
                color="teal"
                size="mini"
                type="button"
                onClick={() => this.props.handleEditModalClose()}
              >
                Cancel
              </Button>
              <Button
                size="mini"
                color="orange"
                type="button"
                disabled={pristine || submitting}
                onClick={reset}
              >
                Clear Values
              </Button>
              <br />
              <br />
              <div>
                <span className="color-mandatory">* </span>Mandatory Fields
              </div>

              <label>Property For</label>
              <span className="color-mandatory"> * </span>
              <Field
                name="propertyFor"
                placeholder="Property For"
                type="text"
                options={propertyForOption()}
                //search={true}
                component={SelectInput}
              />
              {/* <label>Category</label>
              <span className="color-mandatory"> * </span>
              <Field
                name="category"
                placeholder="Category"
                type="text"
                options={category()}
                //search={true}
                component={SelectInput}
              /> */}
              <label>Property Type</label>
              <span className="color-mandatory"> * </span>
              <Field
                name="propertyType"
                placeholder="Property Type"
                type="text"
                options={propertyType()}
                //search={true}
                component={SelectInput}
              />
              {renderSaleOrRentField()}

              <label>Length In Feet</label>
              <Field
                type="number"
                component={NumberInput}
                placeholder="Length In Feet"
                name="length"
              />
              <label>Breadth In Feet</label>
              <Field
                type="number"
                component={NumberInput}
                placeholder="Breadth In Feet"
                name="breadth"
              />

              <label>Carpet Area</label>
              <Field
                type="number"
                component={NumberInput}
                placeholder="Carpet Area"
                name="areaCarpet"
              />
              {areaCarpet > 0 && (
                <>
                  <label>Carpet Area Unit</label>
                  <span className="color-mandatory"> * </span>
                  <Field
                    name="areaCarpetUnit"
                    placeholder="Unit Of Carpet Area"
                    type="text"
                    options={conversionFactors()}
                    //search={true}
                    component={SelectInput}
                  />
                </>
              )}

              <label>Plot Area</label>
              <Field
                type="number"
                component={NumberInput}
                placeholder="Plot Area"
                name="areaPlot"
              />
              {areaPlot > 0 && (
                <>
                  <label>Plot Area Unit</label>
                  <span className="color-mandatory"> * </span>
                  <Field
                    name="areaPlotUnit"
                    placeholder="Unit Of Plot Area"
                    type="text"
                    options={conversionFactors()}
                    //search={true}
                    component={SelectInput}
                  />
                </>
              )}

              <label>Super Area</label>
              <Field
                type="number"
                component={NumberInput}
                placeholder="Super Area"
                name="areaSuper"
              />
              {areaSuper > 0 && (
                <>
                  <label>Super Area Unit</label>
                  <span className="color-mandatory"> * </span>
                  <Field
                    name="areaSuperUnit"
                    placeholder="Unit Of Super Area"
                    type="text"
                    options={conversionFactors()}
                    //search={true}
                    component={SelectInput}
                  />
                </>
              )}

              <label>BuiltUp Area</label>
              <Field
                type="number"
                component={NumberInput}
                placeholder="BuiltUp Area"
                name="areaBuiltUp"
              />
              {areaBuiltUp > 0 && (
                <>
                  <label>BuiltUp Area Unit</label>
                  <span className="color-mandatory"> * </span>
                  <Field
                    name="areaBuiltUpUnit"
                    placeholder="Unit Of BuiltUp Area"
                    type="text"
                    options={conversionFactors()}
                    //search={true}
                    component={SelectInput}
                  />
                </>
              )}
              <label>Rooms</label>
              <Field
                name="bedroom"
                placeholder="Rooms"
                type="text"
                options={bedroom()}
                //search={true}
                component={SelectInput}
              />
              <label>Washrooms</label>
              <Field
                name="bathroom"
                placeholder="Washrooms"
                type="text"
                options={bathroom()}
                //search={true}
                component={SelectInput}
              />
              <label>Store</label>
              <Field
                name="store"
                placeholder="Store"
                type="text"
                options={booleanOption()}
                component={SelectInput}
              />

              <label>Furnished Status</label>
              <Field
                name="furnishedStatus"
                placeholder="Furnished Status"
                type="text"
                options={furnishedStatus()}
                //search={true}
                component={SelectInput}
              />
              <label>Interior</label>
              <Field
                name="interior"
                placeholder="Interior"
                type="text"
                options={interior()}
                //search={true}
                component={SelectInput}
              />
              {/* <label>
                Aprox Value Of Interior Work{" "}
                <span>
                  <b>
                    (
                    {writtenNumber(aproxValueOfWork, {
                      lang: "enIndian",
                    }).toUpperCase()}
                    ){" "}
                  </b>
                </span>
              </label>
              <Field
                type="number"
                component={NumberInput}
                placeholder="Aprox Value Of Work"
                name="aproxValueOfWork"
              /> */}

              <label>AC</label>
              <Field
                name="ac"
                placeholder="AC"
                type="text"
                options={numberOption()}
                search={true}
                component={SelectInput}
              />
              <label>Fan</label>
              <Field
                name="fan"
                placeholder="Fan"
                type="text"
                options={numberOption()}
                search={true}
                component={SelectInput}
              />

              <label>Other Items</label>
              <Field
                type="text"
                component={TextInput}
                placeholder="Other Items"
                name="others"
              />

              <label>Facing</label>
              <Field
                name="facing"
                placeholder="Facing"
                type="text"
                options={facing()}
                //search={true}
                component={SelectInput}
              />
              <label>Entry</label>
              <Field
                name="entry"
                placeholder="Entry"
                type="text"
                options={entry()}
                //search={true}
                component={SelectInput}
              />
              <label>Overlooking</label>
              <Field
                name="Overlooking"
                placeholder="Overlooking"
                type="text"
                options={Overlooking()}
                //search={true}
                component={SelectInput}
              />
              <label>Common Washroom</label>
              <Field
                name="washroomCommon"
                placeholder="Common Washroom"
                type="text"
                options={booleanOption()}
                component={SelectInput}
              />
              <label>Personal Washroom</label>
              <Field
                name="washroomPersonal"
                placeholder="Personal Washroom"
                type="text"
                options={booleanOption()}
                component={SelectInput}
              />
              <label>Personal Pantry</label>
              <Field
                name="pantryPersonal"
                placeholder="Personal Pantry"
                type="text"
                options={booleanOption()}
                component={SelectInput}
              />
              <label>Car Parking</label>
              <Field
                name="parking"
                placeholder=" Parking"
                type="text"
                options={booleanOption()}
                component={SelectInput}
              />
              <label>Reserve Car Parking</label>
              <Field
                name="reserveParking"
                placeholder="Reserve Car Parking"
                type="text"
                options={booleanOption()}
                component={SelectInput}
              />
              <label>Visitor Car Parking</label>
              <Field
                name="visitorParking"
                placeholder="Visitor Car Parking"
                type="text"
                options={booleanOption()}
                component={SelectInput}
              />
              <label>Floor No</label>
              <Field
                name="floorNo"
                placeholder="Floor No"
                type="text"
                options={floorNo()}
                search={true}
                component={SelectInput}
              />
              {/* <label>Show Floor No</label>
              <span className="color-mandatory"> * </span>
              <Field
                name="showFloorNo"
                placeholder="Yes/No"
                type="text"
                options={booleanOption()}
                // search={true}
                component={SelectInput}
              /> */}
              <label>Total Floors</label>
              <Field
                name="totalFloors"
                placeholder="Total Floors"
                type="text"
                options={totalFloors()}
                search={true}
                component={SelectInput}
              />
              <label>Lifts In The Tower</label>
              <Field
                name="liftsInTheTower"
                placeholder="Lifts In The Tower"
                type="text"
                options={booleanOption()}
                //search={true}
                // multiple={true}
                component={SelectInput}
              />
              <label>Type Of Ownership</label>
              <Field
                name="typeOfOwnership"
                placeholder="Type Of Ownership"
                type="text"
                options={typeOfOwnership()}
                //search={true}
                component={SelectInput}
              />
              {propertyFor === "SALE" &&
              <> 
              <label>Status</label>
              <span className="color-mandatory"> * </span>
              <Field
                name="status"
                placeholder="Status"
                type="text"
                options={status()}
                //search={true}
                component={SelectInput}
              />
              </>
              }
              {propertyFor === "SALE" && (
                <>
                  <label>Transaction Type</label>
                  <Field
                    name="transactionType"
                    placeholder="Transaction Type"
                    type="text"
                    options={transactionType()}
                    //search={true}
                    component={SelectInput}
                  />
                </>
              )}
              <label>Possession</label>
              <Field
                name="possession"
                type="text"
                component={DateInput}
                placeholder="Possession"
                dateFormat="dd-MM-yyyy"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />

              <label>Loan Offered By</label>
              <Field
                name="loanOfferedBy"
                placeholder="Loan Offered By"
                type="text"
                options={loanOfferedBy()}
                //search={true}
                component={SelectInput}
              />

              <label>Project Type</label>
              <Field
                name="projectType"
                placeholder="Project Type"
                type="text"
                options={projectType()}
                //search={true}
                component={SelectInput}
              />
              <label>Address</label>
              <Field
                name="address"
                type="text"
                component={TextInput}
                placeholder="Address"
              />
              <label>Complex/Project Name</label>
              <Field
                name="projectName"
                placeholder="Complex/Project Name"
                type="text"
                options={projectNameCom(this.props.projectNameComs)}
                search={true}
                component={SelectInput}
              />
              <label>Locality</label>
              <Field
                name="locality"
                placeholder="Locality"
                type="text"
                options={locality(this.props.localitys)}
                //search={true}
                component={SelectInput}
              />
              {/* <label >Location On Map</label>
        <Field
        name="locationOnMap"
        type="text"
        options={this.locationOnMap()}
        search={true}
        component={SelectInput}
        placeholder="Location On Map"
        /> */}

              {/* <label>Landmarks</label>
              <Field
                name="landmarks"
                placeholder="Landmarks"
                type="text"
                options={this.landmarks()}
                search={true}
                component={SelectInput}
              /> */}
              <label>Amenities</label>
              <Field
                search={true}
                multiple={true}
                name="amenities"
                type="text"
                component={SelectInput}
                options={amenitiesDwarka()}
                placeholder="Amenities"
              />
              <label>Phone Of contact Person</label>
              <Field
                name="phoneOfContactPerson"
                type="text"
                component={TextInput}
                placeholder="Phone Of contact Person"
              />
              <label>Video URL</label>
              <Field
                name="videoPath"
                type="text"
                component={TextInput}
                placeholder="Video URL"
              />
              <label>About/USP of Property</label>
              <Field
                name="description"
                placeholder="About/USP of Property"
                type="text"
                component={TextArea}
                rows={3}
              />

              <label>Property Status</label>
              <span className="color-mandatory"> * </span>
              <Field
                //search={true}
                name="propcomStatus"
                type="text"
                component={SelectInput}
                options={propcomStatus()}
                placeholder="Property Status"
              />
              <label>Property Created On</label>
              <Field
                name="createdAt"
                type="text"
                component={DateInput}
                placeholder="Created On"
                dateFormat="dd-MM-yyyy"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
              {/*  */}
              <br />

              <Button
                color="olive"
                type="submit"
                disabled={pristine || submitting}
              >
                Submit
              </Button>
              <Button
                color="orange"
                type="button"
                disabled={pristine || submitting}
                onClick={reset}
              >
                Clear Values
              </Button>
            </Form>
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      state,
      projectNameComs: state.ggn_name.projectNameComs,
      localitys: state.ggn_name.localitys,
      userA: state.auth.userA,
      initialValues: state.ggn_com_property.propcom,
    }; // pull initial values from account reducer
  },
  { fetchPropCom, resetPropCom, openModal }
)(
  reduxForm({
    form: "PropComEdit", // a unique identifier for this form
    validate,
  })(withRouter(PropComEdit))
);
